var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGovernance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.883 23.207h-22.5a.75.75 0 1 0 0 1.5h22.5a.75.75 0 1 0 0-1.5m-20.5-1h18.5a.75.75 0 1 0 0-1.5h-18.5a.75.75 0 1 0 0 1.5m4.25-13h-2v10.5h2zm4 0h-2v10.5h2zm4 0h-2v10.5h2zm4 0h-2v10.5h2zm-15-1h16a1 1 0 1 0 0-2h-7.5v-1.5h4.5v-3h-4.5v-.25a.75.75 0 1 0-1.5 0v4.75h-7a1 1 0 1 0 0 2"
})));
export default SvgGovernance;